import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const isServer = typeof window === 'undefined';

const client = new ApolloClient({
    ssrMode: isServer,
    link: new HttpLink({
        uri: isServer
            ? process.env.GRAPHQL_URI
            : '/api/graphql',
        headers: isServer
            ? {
                Authorization: `Bearer ${process.env.GRAPHQL_AUTH_TOKEN}`,
            }
            : {},
    }),
    cache: new InMemoryCache(),
});

export default client;